import { takeEvery, call, put } from 'redux-saga/effects';
import {
  dataRequest,
  requestFinished,
  insertUpdateItems as insertUpdateObjectCollectionItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import InfoMaterialsService from '../../../../services/InfoMaterialsService';

function* getInfoMaterialById(reducerName, action) {
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      InfoMaterialsService.getInfoMaterialById,
      action.payload.objectId
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.success) {
        yield put(
          insertUpdateObjectCollectionItems(reducerName, result.destructData)
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, action.payload.objectId, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(dataRequest(reducerName).type, getInfoMaterialById, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/reducers/static/collections/sagas/infoMaterialsCollectionSaga.js